/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable no-template-curly-in-string */
import React, { useContext, useEffect } from 'react';

import { I18nContext } from '../contexts/I18nProvider';

import Spinner from '../components/loaders/Spinner';

const Cruisers = () => {
  const [iframeLoading, setIframeLoading] = React.useState(false);
  const { setActualComponent } = useContext(I18nContext);

  const handleIframeLoad = () => {
    console.log('iframe loaded');

    setIframeLoading(true);
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://cb-lasarenas-nusfer.istinfor.com/includes/jquery/jsparent.js';
    script.async = true;

    document.body.appendChild(script);

    setActualComponent('cruisers');
  }, []);

  return (
    <>
      {!iframeLoading && <Spinner />}

      <iframe
        style={
          iframeLoading
            ? { opacity: 1, minHeight: '100vh' }
            : { opacity: 0, minHeight: '50vh' }
        }
        onLoad={handleIframeLoad}
        name='iframeCruiseSearcher'
        className='iframeCruiseBrowser'
        id='iframeCruiseSearcher'
        src='https://cb-lasarenas-nusfer.istinfor.com/inici.aspx?iframeid=iframeCruiseSearcher'
        async
      />
    </>
  );
};

export default Cruisers;
